export function getAppParams(appParams) {
    var _a;
    return {
        appName: appParams.appName,
        appDefinitionId: appParams.appDefinitionId,
        appVersion: getAppVersion((_a = appParams === null || appParams === void 0 ? void 0 : appParams.baseUrls) === null || _a === void 0 ? void 0 : _a.staticsBaseUrl),
    };
}
export function getAppVersion(viewerScriptUrl) {
    viewerScriptUrl = viewerScriptUrl !== null && viewerScriptUrl !== void 0 ? viewerScriptUrl : '';
    const version = viewerScriptUrl.match(/^https:\/\/static\.parastorage\.com\/services\/[^/]+\/([^/]+)/);
    if (version) {
        return version[1];
    }
    if (viewerScriptUrl.includes('localhost')) {
        return 'localhost';
    }
    return 'not available';
}
//# sourceMappingURL=app-params.js.map